import Flex from "../../../../../components/Flex";
import SearchIcon from "@mui/icons-material/Search";
// import FilterListIcon from '@mui/icons-material/FilterList';
import FaxIcon from "@mui/icons-material/Fax";
import PersonIcon from "@mui/icons-material/Person";
import {
  Paper,
  Avatar,
  Tabs,
  Tab,
  InputAdornment,
  IconButton,
  TextField,
  Typography,
  Chip,
  CircularProgress,
} from "@mui/material";
import Text from "../../../../../components/Text";

interface FaxSideSectionProps {
  faxItems: any[];
  loading?: boolean;
  onScroll?: (el: HTMLElement | null) => void;
  unreadCount?: number;
  allCount?: number;
  searchKey: string;
  activeTab: string;
  setSearchKey: (value: string) => void;
  setActiveTab: (value: string) => void;
  showTabs: boolean;
  setSelectedFax: (value: any) => void;
  selectedFax: any;
}
const FaxSideSection = ({
  faxItems,
  loading,
  onScroll,
  unreadCount,
  allCount,
  searchKey,
  activeTab,
  setSearchKey,
  setActiveTab,
  showTabs,
  setSelectedFax,
  selectedFax,
}: FaxSideSectionProps) => {
  return (
    <Flex
      p={1.2}
      gap={1}
      flexDirection="column"
      width="28.35rem"
      borderRight={"1px solid rgb(229, 224, 224)"}
    >
      <TextField
        placeholder="Search here"
        variant="outlined"
        value={searchKey}
        onChange={(e) => setSearchKey(e.target.value)}
        InputProps={{
          sx: {
            "& .MuiInputBase-input": { fontSize: "14px" },
          },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton size="small">
                <SearchIcon fontSize="small" />
              </IconButton>
              {/* <IconButton size="small">
                <FilterListIcon fontSize="small" />
              </IconButton> */}
            </InputAdornment>
          ),
        }}
      />
      {showTabs && (
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant="fullWidth"
        >
          <Tab
            label={
              <Flex gap={0.5} alignItems="center">
                <Typography fontSize="14px">All</Typography>
                {allCount !== undefined && (
                  <Chip
                    label={allCount}
                    size="small"
                    color="primary"
                    sx={{ minWidth: 20, height: 20, fontSize: "12px" }}
                  />
                )}
              </Flex>
            }
            value="all"
          />
          <Tab
            label={
              <Flex gap={0.5} alignItems="center">
                <Typography fontSize="14px">Unread</Typography>
                {unreadCount !== undefined && (
                  <Chip
                    label={unreadCount}
                    size="small"
                    color="primary"
                    sx={{ minWidth: 20, height: 20, fontSize: "12px" }}
                  />
                )}
              </Flex>
            }
            value="unread"
          />
        </Tabs>
      )}
      <Flex
        flexDirection="column"
        gap={1}
        overflow="auto"
        height="calc(100svh - 20rem)"
        onScroll={(e) => onScroll?.(e.currentTarget)}
      >
        {faxItems?.map((fax: any) => {
          const displayName = fax.callerId || fax.userFaxNumber || "Fax";

          return (
            <Paper
              key={fax.uuid}
              elevation={0}
              sx={{
                p: 1.5,
                cursor: "pointer",
                position: "relative",
                "&:hover": {
                  backgroundColor: "action.hover",
                },
              }}
              onClick={() => setSelectedFax(fax)}
              style={{
                backgroundColor:
                  selectedFax?.uuid === fax.uuid ? "#f0f0f0" : "transparent",
              }}
            >
              <Flex gap={1.5} alignItems="flex-start">
                <Avatar
                  sx={{
                    bgcolor: "primary.main",
                    color: "white",
                    width: 40,
                    height: 40,
                  }}
                >
                  <PersonIcon />
                </Avatar>
                <Flex flexDirection="column" gap={0.5} flex={1}>
                  <Flex gap={1} alignItems="center" flexWrap="wrap">
                    <Text fontWeight={500} fontSize="14px">
                      {displayName}
                    </Text>
                    {fax.faxFlag && (
                      <Chip
                        label="Referral"
                        size="small"
                        color="primary"
                        variant="outlined"
                      />
                    )}
                  </Flex>
                  <Flex gap={1} alignItems="center">
                    <FaxIcon fontSize="small" color="action" />
                    <Text fontSize="12px" color="text.secondary">
                      {fax.callerId ? `+${fax.callerId}` : "-"}
                    </Text>
                  </Flex>
                  <Text fontSize="12px" color="text.secondary">
                    {fax.pages > 1
                      ? `${fax.pages} Documents`
                      : `${fax.pages} Document`}
                  </Text>
                </Flex>
              </Flex>

              <Typography
                fontSize="11px"
                color="text.secondary"
                sx={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                }}
              >
                <Chip
                  label={fax.date ?? fax.dateQueued}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              </Typography>
            </Paper>
          );
        })}
        {loading && (
          <Flex justifyContent="center" sx={{ py: 1 }}>
            <CircularProgress size={18} />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default FaxSideSection;
